import styled from 'styled-components';
import { Button } from 'antd';

export default styled(Button)`
  &.ant-btn {
    &,
    &:hover,
    &:active,
    &:focus {
      color: #1890ff;
      background: none;
      border: none;
      box-shadow: none;
    }

    > * {
      vertical-align: middle;
    }
  }
`;
